import BaseApi from './base'

class KeySetting extends BaseApi {
  getKeySettings = () => this.client.get(`admin/keys-settings`)

  updateKeySettings = (data) => this.client.patch('admin/keys-settings', data)

  uploadFactoryPublicKey = ({ file, comment }) => {
    const formData = new FormData()
    formData.append('files', file)
    formData.append('factoryPublicKeyComment', comment)
    return this.client.patch(
      'admin/keys-settings/factory-public-key',
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
    )
  }

  deleteFactoryPublicKey = () =>
    this.client.delete('admin/keys-settings/factory-public-key')

  getKeySettingsComments = (params) =>
    this.client.get('admin/keys-settings/activities', { params })

  addKeySettingsComment = (data) =>
    this.client.post('admin/keys-settings/activities/comments', data)

  updateKeySettingsComment = ({ commentId, payload }) =>
    this.client.patch(
      `admin/keys-settings/activities/comments/${commentId}`,
      payload
    )

  deleteKeySettingsComment = ({ commentId }) =>
    this.client.delete(`admin/keys-settings/activities/comments/${commentId}`)
}

export default new KeySetting()
